"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteDetailsBanner = exports.SiteDetailsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_details_banner_1 = require("./entity-details-banner");
var use_lang_1 = require("../../hooks/use-lang");
exports.SiteDetailsBannerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 600;\n    text-decoration: none;\n    font-size: 1.4em;\n    margin-bottom: ", ";\n    margin-left: ", ";\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-weight: 600;\n    text-decoration: none;\n    font-size: 1.4em;\n    margin-bottom: ", ";\n    margin-left: ", ";\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(1), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('dark'))
});
var ServerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n    margin-left: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: center;\n\n    b {\n      font-size: 1em;\n      border: 1px solid ", ";\n      border-radius: 20px;\n      margin-left: ", ";\n      display: inline-block;\n      padding: ", " ", ";\n      font-weight: 400;\n      background: ", ";\n      color: ", ";\n      font-family: \"IBM Plex Mono\", monospace;\n    }\n  "], ["\n    display: flex;\n    font-size: ", ";\n    margin-left: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: center;\n\n    b {\n      font-size: 1em;\n      border: 1px solid ", ";\n      border-radius: 20px;\n      margin-left: ", ";\n      display: inline-block;\n      padding: ", " ", ";\n      font-weight: 400;\n      background: ", ";\n      color: ", ";\n      font-family: \"IBM Plex Mono\", monospace;\n    }\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(0.5), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(1), theme_1.theme.UNIT(0.5), theme_1.theme.UNIT(2), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_details_banner_1.EntityDetailsBanner)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled_components_1.default.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  // Slug: styled(EntitySlugLabel)`${SlugStyles}`,
  Server: styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ServerStyles)
};
var SiteDetailsBanner = function (props) {
  var entity = props.entity;
  var t = (0, use_lang_1.useLang)();
  var url = entity.url,
    slug = entity.slug;
  return react_1.default.createElement(My.Container, {
    entity: entity,
    size: "large"
  }, react_1.default.createElement(My.Link, {
    target: "_blank",
    href: url
  }, url), react_1.default.createElement(My.Server, null, t('GraphQL Server'), ": ", react_1.default.createElement("b", null, process.env.GRAPHQL_SERVER)));
};
exports.SiteDetailsBanner = SiteDetailsBanner;
exports.SiteDetailsBanner.defaultProps = exports.SiteDetailsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;